
import SegundaChamadaService from "@/service/v10/sigap/SegundaChamadaService"
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop, Watch } from 'vue-property-decorator';

@Options({
    name: "ProfileSegundaChamadaEditar",
    components: { Multiselect, BotaoSalvar },
    emits: ['segunda-chamada-alterada'],
})
export default class ProfileSegundaChamadaEditar extends Vue {
    @Prop() readonly modal!: any
    @Prop() readonly matricula!: any
    @Prop() readonly disciplinas!: any
    @Prop() readonly status!: any
    @Prop() readonly modelo!: any

    public service = new SegundaChamadaService();
    public processando = false;
    public titulo = 'Atualizar Segunda Chamada';

    public id: any = null;
    public disciplinaId: any = null;
    public dataAvaliacao: any = null;
    public dataSolicitacao: any = null;
    public justificativa: any = null;
    public parecer: any = null;
    public statusId: any = null;

    get disciplinas_select() {
        if (!this.disciplinas) { return null; }
        return this.disciplinas.map((item) => {
            return { value: item.id, label: item.descricao }
        });
    }

    get status_select() {
        if (!this.status) { return null; }
        return this.status.map((item) => { return { value: item.id, label: item.nome } });
    }

    @Watch('modelo')
    public modeloAlterado() {
        if (!this.modelo || !this.modelo.id) {
            return;
        }
        this.processando = true;
        this.service.getModel(this.modelo.id)
            .then(response => {
                this.id = response.id;
                this.disciplinaId = response.disciplina?.id ?? response.disciplinaId;
                this.dataAvaliacao = SiteUtils.formatDataToPadrao(response.dataAvaliacao);
                this.dataSolicitacao = SiteUtils.formatDataToPadrao(response.dataSolicitacao);
                this.justificativa = response.justificativa;
                this.parecer = response.parecer;
                this.statusId = response.status?.id ?? response.status;
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Error!', error.data.message);
            });
    }

    public getdados() {
        const dados: any = {};
        dados.id = this.id;
        dados.matriculaId = this.matricula.id;
        dados.disciplinaId = this.disciplinaId;
        dados.dataAvaliacao = this.dataAvaliacao;
        dados.dataSolicitacao = this.dataSolicitacao;
        dados.justificativa = this.justificativa;
        dados.parecer = this.parecer;
        dados.status = this.statusId;
        return dados;
    }

    public sucesso() {
        this.$emit("segunda-chamada-alterada", null);
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando) {
            return;
        }
        if ( !this.disciplinaId || !this.dataAvaliacao || !this.dataSolicitacao || !this.justificativa ) {
            SiteUtils.toastErro('Error!', 'Preencha os campos obrigatorios.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.update(this.id, dados)
                .then(response => {
                    SiteUtils.toastSucesso('Atualizado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
